export const EXAM_PREP_LABEL = "Mock Tests & Exam Prep";
export const EXAM_PREP_PATH = "/planner?tab=exam-mocks&panel=exam-series";

// Only retain this fixed internal destination; never accept an arbitrary redirect URL.
export function rememberExamPrepDestination() {
  try { sessionStorage.setItem("typogram_exam_prep_return", "1"); } catch { /* Storage can be unavailable. */ }
}

export function consumeExamPrepDestination() {
  try {
    const pending = sessionStorage.getItem("typogram_exam_prep_return") === "1";
    sessionStorage.removeItem("typogram_exam_prep_return");
    return pending ? EXAM_PREP_PATH : null;
  } catch { return null; }
}
